/* eslint-disable */
/**
 * Extracts the timezone offset from the ISO8601 date time format
 * @param {string} dateTimeISO8601 The date and time in ISO8601 format (ex. "2018-12-01T15:00:00+11:00")
 * @returns {number} The offset in minutes
 */
const getTimezoneOffset = (dateTimeISO8601) => {
  const offsetSign = /[+-]/g;
  const [, timeWithTz] = dateTimeISO8601.split(`T`);
  const [, tzOffset] = timeWithTz.split(offsetSign);
  const [sign] = timeWithTz.match(offsetSign);
  return `${sign}${tzOffset}`;
};

export default getTimezoneOffset;
